import { connect } from 'react-redux';
import { matrixRatingChange } from './actions';
import { questionKey } from '../response/reducer';
import PureRatingIcon from './PureRatingIcon';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    curVal: +question.rows[ownProps.rowIndex].value,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: () =>
    dispatch(
      matrixRatingChange(ownProps.value, ownProps.rowIndex, ownProps.questionId)
    ),
});

const MatrixRatingIcon = connect(mapStateToProps, mapDispatchToProps)(
  PureRatingIcon
);

export default MatrixRatingIcon;
